export class GerarPromocaoDTO {
    quantidadeParcelas: number;
    contratoId: number;
    dataPromo: Date;
  }
  